import React from 'react';
import { combineClassNames } from '../../../core/css';
import useLargeBreakpoint from '../../hooks/useLargeBreakpoint';
import { removeKeys } from '../../utils/removeKeys';
import SvgIcon from '../../../core/icons/SvgIcon';
import { TranslateHTML } from '../../../core/translate';

const MatchingKeyFeatures = ({
  features,
  selectedKeyFeatureFilters,
  style,
}) => {
  const { styleIds, groups } = features;

  const codeLookup = removeKeys(groups);

  const valuesForStyle = removeKeys(styleIds[style?.styleId]);

  // TODO: Disclaimer Considerations?
  const rows = selectedKeyFeatureFilters.map((code) => ({
    feature: codeLookup[code],
    value: valuesForStyle[code],
  }));

  const isAtLeastLarge = useLargeBreakpoint();

  const STANDARD = 'standard';
  const NA = 'n/a';

  let rowClass = 'matching-key-features__row--even';
  let invertClass = {
    'matching-key-features__row--odd': 'matching-key-features__row--even',
    'matching-key-features__row--even': 'matching-key-features__row--odd',
  };

  return (
    <div className="matching-key-features__container">
      {rows.map(({ feature, value }, i) => {
        const lowercaseVal = value.toLowerCase();
        const getIconName = () => {
          if (lowercaseVal === STANDARD) return 'check-mark';

          if (lowercaseVal === NA) return 'collapse';

          return null;
        };
        const iconName = getIconName();

        rowClass = i % 2 === 0 ? invertClass[rowClass] : rowClass;

        return (
          <div
            className={combineClassNames(
              'matching-key-features__feature',
              i % 2 === 0
                ? 'matching-key-features__feature--odd'
                : 'matching-key-features__feature--even',
              isAtLeastLarge ? rowClass : ''
            )}
            key={i}>
            <label
              className="matching-key-features__feature__label"
              dangerouslySetInnerHTML={{ __html: feature.description }}
            />
            <label className="matching-key-features__feature__value">
              {iconName && (
                <SvgIcon
                  name={iconName}
                  className={combineClassNames(
                    'button__icon--left',
                    'table-cell__icon'
                  )}
                />
              )}
              <label>
                {lowercaseVal === NA ? (
                  <TranslateHTML value="not.available" />
                ) : (
                  value
                )}
              </label>
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default MatchingKeyFeatures;
